import { ListTodo } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
} from "~/atoms/empty";

interface Props {
  className?: string;
}

export const TodoEmpty = ({ className }: Props) => {
  const { t } = useTranslation();

  return (
    <Empty className={className}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <ListTodo className="text-muted-foreground h-6 w-6" />
        </EmptyMedia>
        <EmptyDescription>
          {t(($) => $.dashboard.myTodos.empty)}
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
